import { useState } from 'react';
import ActivityLog from '~/components/Common/ActivityLog';
import { FiRefreshCw } from 'react-icons/fi';

interface Props {
    campaign: any;
    preloadedActivityLog?: any[];
    setPreloadedActivityLog?: any;
    onCountChange?: (count: number) => void;
}

const ActivityLogTab: React.FC<Props> = ({ campaign, onCountChange }) => {
    const [refreshKey, setRefreshKey] = useState<number>(0);
    const [refreshing, setRefreshing] = useState<boolean>(false);
    const [totalCount, setTotalCount] = useState<number>(0);

    const campaignId = campaign?.id || campaign?.campaign_id;

    const handleRefresh = () => {
        setRefreshing(true);
        setRefreshKey((prev) => prev + 1);
    };

    const handleCountChange = (count: number) => {
        setTotalCount(count);
        onCountChange?.(count);
        setRefreshing(false);
    };

    return (
        <div>
            <div className='mb-3 flex items-center justify-between'>
                <h3 className='text-[16px]/[22px] font-bold'>
                    Activity Log ({totalCount})
                </h3>
                <button
                    onClick={handleRefresh}
                    disabled={refreshing}
                    title='Refresh activity log'
                    className='rounded-full p-1.5 text-body transition-colors hover:bg-gray-100 hover:text-primary disabled:opacity-50'
                >
                    <FiRefreshCw className={`h-4 w-4 ${refreshing ? 'animate-spin' : ''}`} />
                </button>
            </div>
            <ActivityLog campaignId={campaignId} refreshKey={refreshKey} onCountChange={handleCountChange} />
        </div>
    );
};

export default ActivityLogTab;
